import {IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCardContent, IonIcon, IonItem, IonImg} from '@ionic/react';
import {appPages} from './Menu'
import {useHistory} from 'react-router-dom'
import './ExploreContainer.css';
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';

const ExploreContainer: React.FC = () => {
  const history = useHistory()
  const { language } = useContext(LanguageContext);
  return (
    <div>
      <IonGrid>
        <IonRow>
          {appPages.map((appPage, index) => {
            if (index > 0)
            return (
                <IonCol key={index} size="6" onClick={()=> history.push(appPage.url)  } >
                  <IonCard button={true} color="light" className={index % 2 == 0 ? "darkCard homeCards" : "lightCard homeCards"} >
                    <IonItem className="cardItem ion-padding-top" lines="none">
                      <IonIcon icon={appPage.icon} className="indexIcon" />
                    </IonItem>
                    <IonCardHeader mode="md">
                      <IonCardTitle>{language === 'en' ? appPage.indexTitle_en : appPage.indexTitle}</IonCardTitle>
                      <IonCardSubtitle mode="md">{language === 'en' ? appPage.indexSubTitle_en : appPage.indexSubTitle}</IonCardSubtitle>
                    </IonCardHeader>
                  </IonCard>
                </IonCol>
            );
          })}
        </IonRow>
      </IonGrid>
      <div className="footerBar">
        <a href="https://www.agenziapo.it" target="_blank"><IonImg class="ion-margin" slot="start" alt="Logo AIPO" src="assets/images/logo_aipo_b2.png" id="logoAipo" /></a>
        <a href="https://www.adbpo.it" target="_blank"><IonImg class="ion-margin" slot="start" alt="Logo ADBPO" src="assets/images/adbpo_colore.png" id="logoAdbpo" /></a>
      </div>
    </div>
  );
};

export default ExploreContainer;

/*
light blue: 4195bf
dark blue: 0f5783
*/
